<script setup>
import { computed } from 'vue'
import { Head, router } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import ProductCard from '@/Components/Public/ProductCard.vue'
import BrandHero from '@/Components/Public/BrandHero.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()
const props = defineProps({
  tours:     { type: Array,  default: () => [] },
  filters:   { type: Object, default: () => ({}) },
  base_path: { type: String, default: '/tours' }
})

const categories = computed(() => ['boat_trip', 'snorkel', 'island_hopping', 'adventure', 'cultural', 'city', 'other'])

function applyFilter(key, value) {
  router.get(props.base_path, { ...props.filters, [key]: value }, { preserveScroll: true })
}
</script>

<template>
  <Head>
    <title>{{ t('public.tours.head_title') }}</title>
    <meta name="description" :content="t('public.tours.head_description')">
  </Head>

  <BrandHero kind="tour" :title="t('public.tours.title')">
    <p class="bhero-lede">{{ t('public.tours.lede') }}</p>
  </BrandHero>

  <section class="listing">
    <div class="listing__inner">
      <div class="filters filter-bar">
        <button :class="['chip', !filters.category && 'is-active']" @click="applyFilter('category', null)">{{ t('public.tours.filters.all') }}</button>
        <button v-for="cat in categories" :key="cat" :class="['chip', filters.category === cat && 'is-active']" @click="applyFilter('category', cat)">{{ t(`vendor_portal.tour.categories.${cat}`) }}</button>
      </div>

      <p v-if="tours.length === 0" class="empty">{{ t('public.tours.empty') }}</p>

      <ul v-else class="grid">
        <li v-for="tr in tours" :key="tr.id">
          <ProductCard kind="tour" :item="tr" :href="`${base_path}/${tr.id}`" />
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
.bhero-lede { margin: 1rem 0 0; font-size: clamp(1.05rem, 2vw, 1.3rem); line-height: 1.5; max-width: 52ch; opacity: 0.92; }

.listing { --card-accent: var(--warn); background: var(--bg); }
.listing__inner { max-width: 96rem; margin: 0 auto; padding: clamp(1.75rem, 4vw, 2.75rem) clamp(1.25rem, 4vw, 3rem) 4rem; }

.filters { display: flex; gap: 0.5rem; flex-wrap: wrap; margin-bottom: 1.75rem; }
.chip { padding: 0.5rem 1rem; border: 1px solid var(--line); background: var(--surface); border-radius: 999px; font-size: 0.9375rem; color: var(--inkSoft); cursor: pointer; }
.chip.is-active { background: var(--accent); color: var(--accentInk); border-color: var(--accent); }

.empty { padding: 4rem 1rem; text-align: center; color: var(--muted); font-size: 1.0625rem; }

.grid { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr)); gap: 1.25rem; }
</style>
